module.exports = __webpack_public_path__ + "static/media/feature-2.9a5034f5.png";